import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class ContractAPI extends DIApi {
  controllerName = 'Contracts';

  getVoucherReference(idContract) {
    const request = {
      url: this.getAPIUrl() + '/VoucherReference',
      data:{
        idContract: idContract,
      },
    };
    return httpClient.getAsync(request);
  }

  getSumAmountVoucherReference(idContract){
    const request = {
      url: this.getAPIUrl() + '/SumAmountVoucherReference',
      data:{
        idContract: idContract,
      },
    };
    return httpClient.getAsync(request);
  }
}

export default new ContractAPI();
